import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { DotCmsDynamicProducts } from '../dot-cms-product-carousel-list.component';

@Component({
  selector: 'custom-dot-cms-product-swiper',
  templateUrl: './dot-cms-product-swiper.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DotCmsProductSwiperComponent {
  readonly swiperProducts = input<DotCmsDynamicProducts>(undefined);
  productCarouselCss(): string {
    const configureSlides =
      this.swiperProducts().contentlet.slideItems < this.swiperProducts().products.length
        ? this.swiperProducts().contentlet.slideItems
        : this.swiperProducts().products.length;

    switch (configureSlides) {
      case 1: {
        return 'full-container';
      }
      case 2: {
        return 'half-container';
      }
      case 3: {
        return 'three-container';
      }
      default: {
        return 'four-container';
      }
    }
  }
  getProductCarouselTitle() {
    return this.swiperProducts().contentlet.productCarouselTitle;
  }
}
